import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

import { app } from './app';
import { getEmulatorHost, isEmulatorEnabled } from './emulator-config';

export const fns = getFunctions(app, 'europe-west4');

if (isEmulatorEnabled()) {
  connectFunctionsEmulator(fns, getEmulatorHost(), 5001);
}
